// extracted by mini-css-extract-plugin
export var center = "_c-2";
export var clickableRow = "_c-5";
export var expandedRow = "_c-7";
export var hoverable = "_c-4";
export var left = "_c-1";
export var right = "_c-3";
export var row = "_c-0";
export var selectedRow = "_c-6";
export var summaryRow = "_c-8";